import { APP_NAMES } from 'core/variables/constant';

export function closeWebview() {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage('closeWebview');
  }
}

export function isNativeAppWebview() {
  const userAgentAppAvailable = APP_NAMES;
  const isApp = userAgentAppAvailable.some((app) => navigator.userAgent.endsWith(app));

  return isApp;
}
